import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const submitLead = async (payload) => {
  const { data } = await api.post("/leads", payload);
  return data;
};

export const fetchJobs = async () => {
  const { data } = await api.get("/jobs");
  return data;
};

export const fetchJob = async (id) => {
  const { data } = await api.get(`/jobs/${id}`);
  return data;
};

// Multipart helpers (FormData) — let browser set boundary
export const submitApplication = async (formData) => {
  const { data } = await axios.post(`${API}/applications`, formData);
  return data;
};

export const submitCandidate = async (formData) => {
  const { data } = await axios.post(`${API}/candidates`, formData);
  return data;
};

export const fetchFreelancerJobs = async () => {
  const { data } = await axios.get(`${API}/freelancer/me/jobs`);
  return data;
};

export const submitFreelancerCandidate = async (formData) => {
  const { data } = await axios.post(`${API}/freelancer/candidates`, formData);
  return data;
};
